<template>
  <van-action-sheet
    v-model="popupVisible"
    :actions="columns"
    @select="onConfirm"
    cancel-text="取消"
    @cancel="onCancel"
    :round="false"
    :title="title"
  />
</template>

<script>
import { ActionSheet } from 'vant'
export default {
  props: {
    columns: {
      type: Array
    },
    visible: {
      type: Boolean
    },
    type: {
      type: String
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      popupVisible: false,
      value: ''
    }
  },
  watch: {
    visible () {
      this.popupVisible = this.visible
    }
  },
  methods: {
    onConfirm (item) {
      if (this.type) {
        this.$emit('confirm', { value: item, type: this.type })
      } else {
        this.$emit('confirm', { value: item })
      }
    },
    onCancel () {
      this.$emit('cancel')
    }
  },
  components: {
    [ActionSheet.name]: ActionSheet
  }
}
</script>

<style>

</style>
